// router/index.tsx
import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./config";
import { Styles } from "../styles/styles";
import ProtectedRoute from "./ProtectedRoute";
import AdminProtectedRoute from "./AdminProtectedRoute";
import "@ant-design/v5-patch-for-react-19";

const WebsiteSpecPreview =
  process.env.NODE_ENV === "development"
    ? lazy(() => import("../website/v2/preview/WebsiteSpecPreview"))
    : null;

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Routes>
        {WebsiteSpecPreview ? (
          <Route path="/dev/website-spec" element={<WebsiteSpecPreview />} />
        ) : null}
        {WebsiteSpecPreview ? (
          <Route path="/dev/website-spec/:fixture/*" element={<WebsiteSpecPreview />} />
        ) : null}
        {routes.map((routeItem) => {
          const Component = lazy(
            () => import(`../pages/${routeItem.component}`)
          );

          const element = routeItem.admin ? (
            <ProtectedRoute>
              <AdminProtectedRoute>
                <Component />
              </AdminProtectedRoute>
            </ProtectedRoute>
          ) : routeItem.private ? (
            <ProtectedRoute>
              <Component />
            </ProtectedRoute>
          ) : (
            <Component />
          );

          if (Array.isArray(routeItem.path)) {
            return routeItem.path.map((path) => (
              <Route
                key={`${routeItem.component}-${path}`}
                path={path}
                element={element}
              />
            ));
          }

          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              element={element}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

export default Router;
